@if (filteredParameters$ | async; as filteredParameters) {
  <div>
    @if (filteredParameters.length > 0) {
      <div>
        <form
          [formGroup]="form"
          [appPreventSubmitOnEnter]="this.preventSubmitOnEnter"
          (submit)="onSubmit()"
          novalidate
          autocomplete="off"
        >
          <div #contentRef>
            <ng-content></ng-content>
          </div>
          @if (contentRef.children.length === 0) {
            <div>
              <!-- When no custom layout content is provided render parameter controls by rows -->
              <app-parameter-form-rows
                [parameters]="filteredParameters"
                [form]="form"
                [showLabel]="showLabel"
                [showGroup]="showGroup"
                [showUnit]="showUnit"
                [showApplyButton]="showApplyButton"
                [showHelpButton]="showHelpButton"
                [showParameterSpecificViews]="showParameterSpecificViews"
                [showTraceCheckbox]="showTraceCheckbox"
                [showSelectCheckbox]="showSelectCheckbox"
                (apply)="onApply($event)"
                (selectChange)="onSelectChange($event)"
                (parameterSelectedChange)="onParameterSelectChange($event)"
                (parametersSelectionChange)="onParametersSelectionChange($event)"
                (rangeInputChange)="onRangeInputChange($event)"
                (rangeInputInput)="onRangeInputInput($event)"
                (unitChange)="onUnitChange($event)"
              >
              </app-parameter-form-rows>
            </div>
          }
          @if (showSubmit) {
            <div class="form-row mt-2">
              <div class="col-lg" [ngbTooltip]="submitTooltip">
                <button type="submit" class="d-block btn btn-primary w-100" [disabled]="!form.valid || submitDisabled">
                  {{ submitText }}
                </button>
              </div>
            </div>
          } @else {
            <!-- Must have at least submit hidden in order to allow submit on enter -->
            <button type="submit" class="btn d-none btn-primary w-100" [disabled]="!form.valid">&nbsp;</button>
          }
        </form>
      </div>
    } @else {
      @if (showNoSearchResults) {
        <div class="p-2">
          <h6>There are no search results for "{{ searchTerm }}".</h6>
          <p class="mb-0">
            Please ensure that the spelling is correct. You may enter the parameter name or its index number, e.g.
            0x6080.
          </p>
        </div>
      }
    }
  </div>
}

<!-- Templates -->
